import type { FC } from 'react';
import { memo } from 'react';
import { BlockEnum } from '../types';
import { Home, End } from './nodes';
import { ApiTwoTone } from '@ant-design/icons';
import { AssignmentLine } from './index';
// @ts-ignore
import IconCase from '@/components/SoftwareMap/nodes/AR/icons/icon-case.svg?react'
// @ts-ignore
import IconCircle from '@/components/SoftwareMap/nodes/icons/IconCircle.jsx'
// @ts-ignore
import IconFlag from './nodes/icon-flag.svg?react'
// @ts-ignore
import IconNested from './nodes/icon-nested.svg?react'
// @ts-ignore
import IconConnect from '@/components/SoftwareMap/nodes/icons/IconConnect.jsx'


type BlockIconProps = {
  type: BlockEnum;
  size?: string;
  className?: string;
  toolIcon?: string | { content: string; background: string };
};
const ICON_CONTAINER_CLASSNAME_SIZE_MAP: Record<string, string> = {
  xs: 'w-4 h-4 rounded-[5px] shadow-xs',
  sm: 'w-5 h-5 rounded-md ',
  md: 'w-6 h-6 rounded-lg shadow-md',
};
const getIcon = (type: BlockEnum, className: string) => {
  return {
    [BlockEnum.Start]: <IconCircle fill={'#50cb56'} className={className} />,
    [BlockEnum.End]: <IconCircle fill={'#f54b3b'} className={className} />,
    [BlockEnum.Middle]: <IconCase className={className} />,
    [BlockEnum.AssignmentOnline]: <IconFlag style={{ color: '#17b26a' }} />,
    [BlockEnum.AssignmentOffline]: <IconFlag style={{ color: '#676f83' }} /> ,
    [BlockEnum.Mirror]: <IconConnect fill={'#287ef6'} />,
    [BlockEnum.NestedFlow]: <IconNested style={{ color: '#17b26a' }} />,
  }[type];
};
const ICON_CONTAINER_BG_COLOR_MAP: Record<string, string> = {
  [BlockEnum.Start]: 'text-util-colors-blue-brand-blue-brand-500',
  [BlockEnum.End]: 'text-util-colors-warning-warning-500',
  [BlockEnum.Middle]: '',
  [BlockEnum.AssignmentOnline]: '',
  [BlockEnum.AssignmentOffline]: '',
  [BlockEnum.Mirror]: '',
  [BlockEnum.NestedFlow]: '',
};
const BlockIcon: FC<BlockIconProps> = ({
  type,
  size = 'sm',
  className,
  toolIcon,
}) => {
  return (
    <div
      className={`
      flex items-center justify-center border-[0.5px] border-white/2 text-white
      ${ICON_CONTAINER_CLASSNAME_SIZE_MAP[size]}
      ${ICON_CONTAINER_BG_COLOR_MAP[type]}
      ${toolIcon && '!shadow-none'}
      ${className}
      ${type === BlockEnum.NestedFlow && '!bg-white'}
    `}
    >
      {getIcon(type, size === 'xs' ? 'w-3 h-3' : 'w-3.5 h-3.5')}
    </div>
  );
};

export const VarBlockIcon: FC<BlockIconProps> = ({ type, className }) => {
  return <>{getIcon(type, `w-3 h-3 ${className}`)}</>;
};

export default memo(BlockIcon);
